import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Questions from '../views/Questions.vue'
import ProductDetail from '../views/ProductDetail'
import FilterProduct from '../views/FilterProduct'
import Login from '../views/Login'
import Privacy from '../views/Privacy'
import ReturnPolicy from '../views/ReturnPolicy'
import CommentsAndSuggestions from '../views/CommentsAndSuggestions'
import UserProfile from '../views/UserProfile'
import Checkout from '../views/Checkout'
import GofarmaInYourCompany from '../views/GofarmaInYourCompany'
import ElectronicBilling from '../views/ElectronicBilling'
import Gofarma from '../views/Gofarma'
import RecoveryPassword from '../views/RecoveryPassword'
import ForgotPassword from '../views/ForgotPassword'
import RecoverUser from '../views/RecoverUser'
import Publish from '../views/Publish'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/preguntas-frecuentes',
    name: 'questions',
    component: Questions
  },
  {
    path: '/producto/:slug',
    name:'detalle',
    component:ProductDetail
  },
  {
    path: '/filtro',
    name:'filterProduct',
    component:FilterProduct
  },
  {
    path:'/identificarse',
    name:'login',
    component:Login
  },
  {
    path:'/aviso-de-privacidad',
    name:'privacy',
    component:Privacy
  },
  {
    path:'/cambios-y-devoluciones',
    name:'returnPolicy',
    component:ReturnPolicy
  },
  {
    path:'/comentarios-y-sugerencias',
    name:'commentsAndSuggestions',
    component:CommentsAndSuggestions
  },
  {
    path:'/mi-perfil',
    name:'userProfile',
    component:UserProfile
  },
  {
    path:'/confirmar-compra',
    name:'checkout',
    component:Checkout
  },
  {
    path:'/gofarma-en-tu-empresa',
    name:'gofarmaInYourCompany',
    component:GofarmaInYourCompany
  },
  {
    path:'/facturacion-electronica',
    name:'electronicBilling',
    component:ElectronicBilling
  },
  {
    path:'/quienes-somos',
    name:'gofarma',
    component:Gofarma
  },
  {
    path:'/recuperar/*',
    name:'recovery',
    component:RecoveryPassword
  },
  {
    path:'/olvide-mi-contraseña',
    name:'forgotPassword',
    component:ForgotPassword
  },
  {
    path:'/recuperar-usuario',
    name:'RecoverUser',
    component:RecoverUser
  },
  {
    path:'/completada',
    name:'Publish',
    component:Publish
  }
]

const router = new VueRouter({
  routes,
  mode: 'history',
  scrollBehavior: function () {
    return { x: 0, y: 0 }
  }
})

export default router
